import BackgroundFileTranslationsRequest from '../../../../../Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileTranslationsRequest';
import CropAndSaveImageRequest from '../../../../../Spirit/Common/FileManager/Models/CropAndSaveImageRequest';

export default class BackgroundFileAddRequest  {
	Id?: string = '';
	AnimationId?: string = '';
	Translations: Array<BackgroundFileTranslationsRequest> = null;
	BackImage: CropAndSaveImageRequest = null;
	CoverImage: CropAndSaveImageRequest = null;
	Base64Content?: string = '';
	constructor(obj?: Partial<BackgroundFileAddRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
